import { dataExclamationTriangle } from 'dls-icons-data'
import { createIcon } from '../common'

const IconExclamationTriangle = /*#__PURE__*/createIcon(dataExclamationTriangle)
export default IconExclamationTriangle
